export const comments_3296366 = {"data":{"data":[],"links":{}}}